const t2tPie = (data) => {
  const defaultConfig = {
      title: {
          text: 'Ploidy',
          // 副标题
          x: 'center',
          y: 'center',
          // 主标题样式
          textStyle: {
              fontSize: '20',
              color: 'black'
          },
          // 副标题样式
          subtextStyle: {
              fontSize: '20',
              fontWeight: '800',
              color: 'black'
          }
      },
      tooltip: {
        trigger: 'item'
      },
      color: ['#91cc75', '#409eff', '#f56c6c', '#fac858', '#706caa'],
      legend: {
        show: false,
        type: 'scroll',
        top: '5%',
        // bottom: '1%',
        // left: 'center'
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: true,
          padAngle: 5,
          itemStyle: {
            borderRadius: 10,
            borderWidth: 3,  // 设置边框宽度，来创建间隙
            borderColor: '#fff'  // 设置间隙的颜色
          },
          label: {
            alignTo: 'edge',
            show: true, // 直接显示标签
            position: 'outside', // 让标签显示在外面
            formatter: '{b}\n({per|{d}%})', // 显示类别名和数量
            fontSize: 14,
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              time: {
                fontSize: 10,
                color: '#999'
              }
            }
          },
          labelLine: {
            length: 15,
            length2: 0,
            maxSurfaceAngle: 80
          },
          data: data,
        },
      ]
    }
    const opt = Object.assign({}, defaultConfig)

return opt
}
export default t2tPie